import React from 'react';
import classnames from 'classnames';

import styles from './item.scss';
import fileIcon from 'ub/icons/asset-library/file.svg';

export default function Item({
  children,
  isSelected,
  title,
  onClick,
  onDoubleClick,
  onDelete,
  style,
  thumbnailImage,
}) {
  return (
    <div
      className={classnames(styles.wrapper, { [styles.isSelected]: isSelected })}
      title={title}
      style={style}
    >
      <div onClick={onClick} onDoubleClick={onDoubleClick} className={styles.thumbnail}>
        {thumbnailImage ? (
          <img src={thumbnailImage} />
        ) : (
          // eslint-disable-next-line react/no-danger
          <div className={styles.fileIcon} dangerouslySetInnerHTML={{ __html: fileIcon }} />
        )}

        {onDelete && (
          <a onClick={onDelete} className={styles.deleteButton}>
            <div className="svg-ico-delete" />
          </a>
        )}
      </div>

      <p className={styles.label}>{children}</p>
    </div>
  );
}

Item.propTypes = {
  children: React.PropTypes.node,
  isSelected: React.PropTypes.bool.isRequired,
  onClick: React.PropTypes.func,
  onDoubleClick: React.PropTypes.func,
  onDelete: React.PropTypes.func,
  style: React.PropTypes.object,
  thumbnailImage: React.PropTypes.string,
  title: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/asset-library/item.jsx